export enum HotelCategoryFlag {
  None = 0,
  Luxury = 1,
  Coast = 2,
  City = 4,
  Mountain = 8,
  Boutique = 16,
  Business = 32,
  Family = 64,
}

export type HotelCategoryFilter = "all" | HotelCategoryFlag;

export const HOTEL_CATEGORY_OPTIONS: Array<{
  id: HotelCategoryFlag;
  key: string;
  labelKey: string;
}> = [
  { id: HotelCategoryFlag.Luxury, key: "luxury", labelKey: "publicBooking.categoryLuxury" },
  { id: HotelCategoryFlag.Coast, key: "coast", labelKey: "publicBooking.categoryCoast" },
  { id: HotelCategoryFlag.City, key: "city", labelKey: "publicBooking.categoryCity" },
  { id: HotelCategoryFlag.Mountain, key: "mountain", labelKey: "publicBooking.categoryMountain" },
  { id: HotelCategoryFlag.Boutique, key: "boutique", labelKey: "publicBooking.categoryBoutique" },
  { id: HotelCategoryFlag.Business, key: "business", labelKey: "publicBooking.categoryBusiness" },
  { id: HotelCategoryFlag.Family, key: "family", labelKey: "publicBooking.categoryFamily" },
];

export const hasHotelCategory = (value: number | undefined, category: HotelCategoryFlag) =>
  ((value ?? HotelCategoryFlag.None) & category) === category;

export const toggleHotelCategory = (value: number | undefined, category: HotelCategoryFlag) =>
  hasHotelCategory(value, category)
    ? (value ?? HotelCategoryFlag.None) & ~category
    : (value ?? HotelCategoryFlag.None) | category;

export const getSelectedHotelCategories = (value: number | undefined) =>
  HOTEL_CATEGORY_OPTIONS.filter((category) => hasHotelCategory(value, category.id));

export const getPrimaryHotelCategory = (value: number | undefined) =>
  getSelectedHotelCategories(value)[0]?.id ?? HotelCategoryFlag.City;
